import { get_schema } from "utils/ajax";

const preFetchArray = [];

/**
 * 全局状态
 */
const global = {
  namespaced: true,
  state: {
    //  ajax 请求 global.json是否完成
    preloading: false,
    //  此处为true时意味着整个加载动画已经执行完毕, 并且已经消失
    preloadingDone: false,
    //  存储调取api返回的schema
    schema: {},
    //  是否显示侧边栏
    isShowAside: false,
    //  是否处于离线状态
    dc: false,
    //  是否是版权署名页面显示
    isCopyrightShow: false,
    //  默认正文文字字号
    changeFontSize: 20,
    //  scrollNextAnimate
    scrollNextAnimate: false,
    //  当前字体状态
    fontStatus: false,
  },
  action: {},
  mutations: {
    updateScrollNextAnimate(state, payload) {
      state.scrollNextAnimate = payload;
    },
    //  调用此方法时意味着 global.json 已加载完毕
    updatePreloading(state) {
      state.preloading = true;
    },
    //  调用此方法时意味着 加载动画已完成, 且完全消失
    updatePreloadingDone(state) {
      state.preloadingDone = true;
    },
    //  更新schema
    updateSchema(state, payload) {
      state.schema[payload.name] = payload.value;
    },
    //  更新isShowAside
    updateIsShowAside(state) {
      state.isShowAside = !state.isShowAside;
    },
    updateIsCopyrightShow(state, payload) {
      state.isCopyrightShow = payload;
    },
    //  更新字体大小
    updateFontSize(state, fontSize) {
      state.changeFontSize = fontSize;
    },
    //   缅甸语当前字体
    updateFontStatus(state, status) {
      state.fontStatus = status;
    },
  },
  getters: {
    preloading: (state) => state.preloading,
    apiUri: (state) => state.schema.global.item.apiUri.data.lrcApiUri,
    aside: (state) => state.schema.global.item.aside.data,
    asideMoreInfo: (state) => state.schema.global.item.asideMoreInfo.data.html,
    copyrightContent: (state) =>
      state.schema.global.item.copyrightContent.data.html,
    facebookUserName: (state) =>
      state.schema.global.item.facebookUserName.data.userName,
    followUs: (state) => state.schema.global.item.followUs.data,
    logo: (state) => state.schema.global.item.logo.data,
  },
};

export default global;
